import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

class ManagementListHeader extends Component {
  render() {
    const { onQueryChange, query, onTempChange } = this.props;
    return (
      <React.Fragment>
        <div className="p-inputgroup">
          <InputText
            value={query}
            onChange={event => onTempChange(event.target.value)}
          />
          <Button
            icon="pi pi-search"
            onClick={() => onQueryChange(query)}
          />
        </div>
      </React.Fragment>
    );
  }
}

ManagementListHeader.propTypes = {
  onQueryChange: PropTypes.func.isRequired,
  onTempChange: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
};

export default withRouter(injectIntl(ManagementListHeader));
